module.exports = __webpack_public_path__ + "img/responses.8dd9f74f.svg";